export interface ChatDeliveryEntry {id?:string;role?:unknown;timestamp?:unknown;deliveredAt?:number;deliveredAfterIds?:string[]}
const timeOf=(entry:ChatDeliveryEntry)=>typeof entry.timestamp==='number'?entry.timestamp:Number(entry.id?.match(/(\d{13})(?:\D.*)?$/)?.[1]??0);
/** Move only delivered answer bubbles. Tool rows and intervening user messages retain their order. */
export function orderChatDeliveries<T extends ChatDeliveryEntry>(rows:T[]):T[]{
 const delivered=rows.filter(row=>row.role==='assistant' && typeof row.deliveredAt==='number').sort((a,b)=>a.deliveredAt!-b.deliveredAt!);
 const result=rows.filter(row=>!delivered.includes(row));
 for(const row of delivered){
  let after=-1;
  for(let index=0;index<result.length;index++){
   const candidate=result[index];
   if(row.deliveredAfterIds ? !!candidate.id && row.deliveredAfterIds.includes(candidate.id) : (candidate.deliveredAt??timeOf(candidate))<=row.deliveredAt!) after=index;
  }
  result.splice(after+1,0,row);
 }
 return result;
}
export function deliverChatReply<T extends ChatDeliveryEntry>(rows:T[],id:string,patch:Partial<T>,now=Date.now()):T[]{
 return orderChatDeliveries(rows.map(row=>row.id===id?{...row,...patch,deliveredAt:row.deliveredAt??now,deliveredAfterIds:row.deliveredAfterIds??rows.filter(other=>other.id!==id && (other.role==='user'||typeof other.deliveredAt==='number')).flatMap(other=>other.id?[other.id]:[])}:row));
}
export class ActiveChatRequests<T>{
 private readonly requests=new Map<string|number,Set<T>>();
 add(project:string|number,request:T){const active=this.requests.get(project)??new Set<T>();active.add(request);this.requests.set(project,active);}
 delete(project:string|number,request:T){const active=this.requests.get(project);active?.delete(request);if(!active?.size)this.requests.delete(project);}
 has(project:string|number){return !!this.requests.get(project)?.size;}
 hasOther(project:string|number,request:T){return Array.from(this.requests.get(project)??[]).some(value=>value!==request);}
}
